import React, { useRef, useState } from "react";
import './UploadImagePopup.scss';
import { Link } from "react-router-dom";
import { SKIN_ASM_CONSTANTS } from "../../../../../common/skinAssessmentConstant";
import SkinAssessmentButton from "../../../../../common/skinAssessmentButton/SkinAssessmentButton";

const UploadImagePopup = ({ title, skipUpload, onUploadClick }) => {

    return (<div className="image-upload-backdrop">
        <div className="image-upload-wrapper">
            <div className="image-upload-header">
                <span>{title}</span>
            </div>
            <div className="image-upload-card">
                <img src="/images/skin-assessment/skin-asm-image-upload.png" className="image-upload-img" />
                <div className="image-upload-content">
                    <div className="link-upload-from-gallery">
                        <Link className="" to="#" onClick={(e) => {
                            e.preventDefault();
                            onUploadClick();
                        }}>{SKIN_ASM_CONSTANTS.UPLOAD_FROM_GALLERY}</Link>
                    </div>
                    <div className="image-size-description">{SKIN_ASM_CONSTANTS.IMAGE_SIZE_DESC}</div>
                    <div className="image-section-separator">
                        <hr className="line-1" />
                        <span className="span-1">หรือ</span>
                        <hr className="line-2" />
                    </div>
                    <SkinAssessmentButton onBtnClick={onUploadClick} btnClassName='footer-active'>{SKIN_ASM_CONSTANTS.CAMERA_UPLOAD_BTN}</SkinAssessmentButton>
                    <div className="skip-image-upload-link">
                        <Link className="" to="#" onClick={(e) => {
                            e.preventDefault();
                            skipUpload();
                        }}>{SKIN_ASM_CONSTANTS.SKIP_UPLOAD}
                        </Link>
                    </div>
                </div>
            </div>
        </div>

    </div>)
}

export default UploadImagePopup;